import React from "react";
import propTypes from "prop-types";
import Select from "react-select";
import api from "../../../../utils/Api";
import { AUTH_TOKEN_KEY } from "../../../../constants";

class SelectSize extends React.Component {
  constructor(props) {
    super(props);
    this._loadSizeOptions = this._loadSizeOptions.bind(this);
  }

  _loadSizeOptions(input) {
    const token = localStorage.getItem(AUTH_TOKEN_KEY);
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    const params = {
      category: "sneakers",
    };
    if (input) {
      params.keyword = input;
    }
    return api(headers)
      .get("/sizes", { params })
      .then(({ data }) => {
        const options = (data.data || []).map((item) => ({
          id: item.US,
          label: `US ${item.US}`,
        }));
        return { options };
      })
      .catch(() => ({ options: [] }));
  }

  render() {
    return (
      <Select.Async
        key={this.props.selectKey}
        valueKey="id"
        labelKey="label"
        defaultOptions
        ref={this.props.id}
        loadOptions={this._loadSizeOptions}
        cacheOptions={this.props.cacheOptions}
        name={this.props.name}
        value={this.props.value}
        placeholder={this.props.placeholder}
        noResultsText={this.props.noResultsText}
        onChange={this.props.onSelectChange}
        onOpen={this.props.onSelectOpen}
        multi={this.props.isMulti}
      />
    );
  }
}

SelectSize.defaultProps = {
  cacheOptions: false,
  value: null,
  placeholder: "Select a size...",
  noResultsText: "No Result!",
  isMulti: false,
  selectKey: undefined,
};

SelectSize.propTypes = {
  name: propTypes.string,
  value: propTypes.oneOfType([
    propTypes.object,
    propTypes.array,
    propTypes.string,
  ]),
  placeholder: propTypes.string,
  noResultsText: propTypes.string,
  cacheOptions: propTypes.bool,
  isMulti: propTypes.bool,
  onSelectChange: propTypes.func,
  onSelectOpen: propTypes.func,
  id: propTypes.string,
  selectKey: propTypes.oneOfType([propTypes.string, propTypes.number]),
};

export default SelectSize;
